import { Link } from "react-router-dom";
import SideBarADM from "../SideBarADM";
import "../sidebarADM.css";
import { getExpositoresUsers } from "../../../api/admin.js";
import { sendUsersProfiles } from "../../../api/admin.js";
import { useQuery } from "react-query";
import { NRoundedButton, DashInput } from "../../../shared-components";
import useFilter from "./useFilter";
import { CardProfile } from "./CardProfile";


const SolicitCadastroADM = () => {

  const { data: expositores, isLoading } = useQuery(
    "profiles-builds",
    getExpositoresUsers
  );

  const {
    handleFilter,
    searchTerm,
    setSearchTerm,
    filteredProfiles,
    filter,
    setFilter,
  } = useFilter(expositores);

  if (isLoading) {
    return <></>;
  }

  const handleClearFilter = () => {
    setFilter("all");
  };

  const handleAccept = async (userId, status) => {
    const res = await sendUsersProfiles(userId, status);
    console.log(res);
  };

  return (
    <div className="cont-geral">
      <SideBarADM />
      <div className="btns-solict2">
        <Link to="/solicitacao-cadastro-admin">
          <button className="expo-btn">expositor</button>
        </Link>
        <Link to="/solicitacao-cadastro-promotor">
          <button className="promotor-btn1">promotor</button>
        </Link>
        <Link to="/solicitacao-cadastro-montador">
          <button className="montador-btn1">montador</button>
        </Link>
        <Link to="/solicitacao-cadastro-projetista">
          <button className="proj-btn1">projetistas</button>
        </Link>
        <div className="search-input-admin">
          <DashInput
            value={searchTerm}
            placeholder={"Busque por um termo..."}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <NRoundedButton
            title={"aprovado"}
            active={filter === "APROVADO"}
            color={"#FF8400"}
            onClick={() => handleFilter("APROVADO")}
          />
          <NRoundedButton
            title={"pendente"}
            active={filter === "PENDENTE"}
            color={"#FF8400"}
            onClick={() => handleFilter("PENDENTE")}
          />
          <NRoundedButton
            title={"reprovado"}
            active={filter === "REPROVADO"}
            color={"#FF8400"}
            onClick={() => handleFilter("REPROVADO")}
          />
          <NRoundedButton
            title={"mostrar todos"}
            color={"#FF8400"}
            onClick={handleClearFilter}
            active={filter === "all"}
          />
        </div>
      </div>

      <div className="multiple-options">
        {filteredProfiles?.map((expositor) => (
          <CardProfile
            key={expositor.id}
            profile={expositor}
            handleAccept={handleAccept}
          />
        ))}
      </div>
    </div>
  );
};

export default SolicitCadastroADM;
